import 'babel-polyfill';
import './app/styles/main.less';
import 'moment/locale/sk';
import React from 'react';
import { render } from 'react-dom';
import { hashHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { Root } from './app/containers';
import configureStore, { fetchSettings } from './app/store/configureStore';
import { prepareRequestInterceptor, handleResponsesInterceptor } from './common/services/apiClient';
import { relogin } from './features/auth/ducks';

window.Raven.config('https://0554192b9aeb4cc0944550fc7e4b2a63@sentry.io/246064', {
  environment: process.env.NODE_ENV,
}).install();



async function init() {
  await fetchSettings();

  const store = await configureStore();
  const history = syncHistoryWithStore(hashHistory, store);

  prepareRequestInterceptor(store);
  handleResponsesInterceptor(store);

  const state = store.getState();

  if (state && state.auth) {
    store.dispatch(relogin(state.auth));
  }


  render(<Root store={store} history={history} />, document.getElementById('root'));
}

init();





// WEBPACK FOOTER //
// ./src/index.js